import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["inert"]
const _hoisted_2 = { class: "studio-file-search" }
const _hoisted_3 = {
  class: "studio-file-items",
  "aria-label": "文件列表"
}
const _hoisted_4 = ["aria-pressed", "title", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "studio-file-menu"
}
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = {
  key: 0,
  class: "studio-sidebar-hint"
}
const _hoisted_8 = { class: "studio-file-actions" }

import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import StudioIcon from "./StudioIcon.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'StudioFileList',
  props: {
    values: {},
    selectedValue: {},
    disabled: { type: Boolean }
  },
  emits: ["select", "add", "delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const search = ref("");
const fileList = ref<HTMLElement>();
const visibleFiles = computed(() => props.values.filter(name => name.toLocaleLowerCase().includes(search.value.trim().toLocaleLowerCase())));
function closeFileMenuOutside(event: PointerEvent) {
  const menu = fileList.value?.querySelector<HTMLDetailsElement>(".studio-file-menu[open]");
  if (menu && !event.composedPath().includes(menu)) menu.open = false;
}
onMounted(() => document.addEventListener("pointerdown", closeFileMenuOutside, true));
onBeforeUnmount(() => document.removeEventListener("pointerdown", closeFileMenuOutside, true));
function remove(event: Event) {
  (event.currentTarget as HTMLElement).closest("details")?.removeAttribute("open");
  emit("delete");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "fileList",
    ref: fileList,
    class: "studio-file-list",
    inert: __props.disabled
  }, [
    _createElementVNode("label", _hoisted_2, [
      _createVNode(StudioIcon, { name: "search" }),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        type: "search",
        placeholder: "搜索文件…",
        "aria-label": "搜索文件"
      }, null, 512), [
        [_vModelText, search.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleFiles.value, (file) => {
        return (_openBlock(), _createElementBlock("div", {
          key: file,
          class: _normalizeClass(["studio-file-row", { selected: __props.selectedValue === file }])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "studio-file-select",
            "aria-pressed": __props.selectedValue === file,
            title: file,
            onClick: ($event: any) => (emit('select', file))
          }, [
            _createVNode(StudioIcon, { name: "file" }),
            _createElementVNode("span", null, _toDisplayString(file), 1)
          ], 8, _hoisted_4),
          (__props.selectedValue === file)
            ? (_openBlock(), _createElementBlock("details", _hoisted_5, [
                _createElementVNode("summary", {
                  "aria-label": `${file} 的操作`
                }, [
                  _createVNode(StudioIcon, { name: "more" })
                ], 8, _hoisted_6),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: remove
                  }, [
                    _createVNode(StudioIcon, {
                      name: "trash",
                      size: 15
                    }),
                    _cache[2] || (_cache[2] = _createTextVNode("删除文件", -1))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128)),
      (!visibleFiles.value.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(search.value.trim() ? '没有匹配的文件' : '还没有文件，创建一份开始编辑。'), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('add')))
      }, [
        _createVNode(StudioIcon, {
          name: "plus",
          size: 16
        }),
        _cache[3] || (_cache[3] = _createTextVNode("新建文件", -1))
      ]),
      _renderSlot(_ctx.$slots, "actions")
    ])
  ], 8, _hoisted_1))
}
}

})